import { useEffect, useState } from "react";

/* One answer to "is this a phone?" for the whole app: the viewport, not the
   user agent. Under this width the cockpit and the portal change shape. */
const QUERY = "(max-width: 760px)";

export function isMobileNow(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(QUERY).matches;
}

export function useIsMobile(): boolean {
  const [m, setM] = useState(isMobileNow);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(QUERY);
    const f = () => setM(mq.matches);
    f();
    if (mq.addEventListener) mq.addEventListener("change", f); else mq.addListener(f);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", f); else mq.removeListener(f); };
  }, []);
  return m;
}
